function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

export function getOverrideProductSellingPlanId(overrideProduct, snsIntervalWeeks) {
  var sellingPlanId = null;
  var sellingPlans = overrideProduct.sellingPlanGroups.reduce(function (list, grp) {
    return [].concat(_toConsumableArray(list), _toConsumableArray(grp.sellingPlans));
  }, []);

  if (snsIntervalWeeks) {
    var deliveryPattern = new RegExp("Delivery every ".concat(snsIntervalWeeks, " Weeks"), 'i');
    var sellingPlan = sellingPlans.find(function (sp) {
      return deliveryPattern.test(sp.name);
    });

    if (sellingPlan) {
      sellingPlanId = sellingPlan.id;
    } else {
      console.error("Unable to find selling plan with matching week interval: ".concat(snsIntervalWeeks), {
        deliveryPattern: deliveryPattern,
        sellingPlans: sellingPlans
      });
    }
  }

  return sellingPlanId;
}